$(".switch-content:first-child").addClass("active");
$(".switch-nav").find("tr").find(".switch-button:first-of-type").addClass("active");

$("#free-time").nl_switch_content();



var numberOfTd = $(".switch-nav").find("td").length;

$(".switch-nav").find("td").css("width", (100 / numberOfTd) + "%");

var $grid =  $("#free-time").find(".switch-content").masonry({
    itemSelector: '.description',
    columnWidth: '.description',
    percentPosition: true
});



$(document).on("bodyLoaded", function () {
    $grid.masonry();
});

